import { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import LazyLoad from "react-lazy-load";
import Lightbox from "yet-another-react-lightbox";

// Lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { DownloadPlugin } from "./plugins/DownloadPlugin";

// Styles
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// import photos from "./photos";
import { photos, slides } from "assets/photos";

// Components
import ImageContentLoader from "./ImageContentLoader";

const Image = ({ src, alt, onLoad, onClick, conditionalProps = {} }) => {
  const [complete, setComplete] = useState(false);

  return (
    <>
      {!complete ? <ImageContentLoader /> : null}
      <LazyLoad style={{ background: "#000" }}>
        <img
          src={src}
          alt={alt ?? ""}
          {...(!complete ? { hidden: true } : {})}
          onLoad={() => {
            if (onLoad) onLoad();
            setComplete(true);
          }}
          onError={(e) => {
            e.target.onerror = null;
            setComplete(true);
          }}
          onClick={(e) => {
            if (onClick) onClick();
          }}
          style={{
            maxWidth: "100%",
            width: "100%",
            padding: 0,
            cursor: "pointer",
          }}
          {...conditionalProps}
        />
      </LazyLoad>
    </>
  );
};

const Gallery = ({ type }) => {
  const [index, setIndex] = useState(-1);

  const filteredPhotos = photos.filter((e, i) => {
    return e.type === type;
  });

  const filteredSlides = slides.filter((e, i) => {
    return e.imgType === type;
  });

  return (
    <>
      <ResponsiveMasonry
        columnsCountBreakPoints={{
          350: 1,
          750: 2,
          900: 3,
          1200: 4,
          1500: 5,
          1900: 6,
        }}
      >
        <Masonry gutter="10px">
          {filteredPhotos.map((e, i) => (
            <div key={i}>
              <Image
                alt={e.alt}
                onClick={() => setIndex(i)}
                src={e.src}
                style={{ maxWidth: "100%", width: "100%", padding: 0 }}
              />
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      <Lightbox
        slides={filteredSlides}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        // enable optional lightbox plugins
        plugins={[Fullscreen, Slideshow, DownloadPlugin, Thumbnails, Zoom]}
      />
    </>
  );
};

export default Gallery;
